export const PANEL_SIMPLE_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Heads Up",
    text: "Some upcoming changes may impact your project timelines or dependencies. Please review the latest updates in your team’s backlog and flag any blockers early. Staying proactive here will save everyone time down the line.",
    accentColor: { light: "#FFF7D6", dark: "#FFF7D6" },
    textColor: { light: "#533F04", dark: "#533F04" },
    displayElements: ["icon", "title", "text"],
    type: "standard",
    design: "warning",
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Quick Win",
    text: "We’ve successfully wrapped up a key milestone ahead of schedule! This is a great achievement and a reflection of everyone’s focus and collaboration. Let’s capture what worked well here and apply it to the next sprint to keep the momentum going.",
    accentColor: { light: "#DCFFF1", dark: "#DCFFF1" },
    textColor: { light: "#216E4E", dark: "#216E4E" },
    displayElements: ["icon", "title", "text"],
    type: "standard",
    design: "success",
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Action Required",
    text: "Your input is urgently needed to move forward. Please take a moment to review the attached proposal and share your feedback by EOD Friday. Delays at this stage will affect the overall delivery timeline, so prompt action is crucial.",
    accentColor: { light: "#FFECEB", dark: "#FFECEB" },
    textColor: { light: "#AE2E24", dark: "#AE2E24" },
    displayElements: ["icon", "title", "text"],
    type: "standard",
    design: "error",
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Insight Drop",
    text: "Our latest data shows a 15% increase in customer satisfaction scores this quarter. This improvement is a direct result of the recent process changes and team efforts. Let’s take a closer look at what’s driving this success and explore how we can amplify it further across other teams.",
    accentColor: { light: "#E9F2FF", dark: "#E9F2FF" },
    textColor: { light: "#0055CC", dark: "#0055CC" },
    displayElements: ["icon", "title", "text"],
    type: "standard",
    design: "warning",
  },

  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Gift Boxes",
    text: "We're sending gift boxes to our top-selling partners as a token of appreciation and to strengthen our personal connections. This is especially important for partners who have been less engaged, giving us a thoughtful way to reconnect.",
    accentColor: { light: "#ff2fd2", dark: "#ff2fd2" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_icon",
    icon: "bootstrap/Gift",
    colorMute: true,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Confidential Information",
    text: "The information below is confidential and intended for internal use only. Please do not share it outside the company or with unauthorized individuals. If you have any questions about data security or sharing guidelines, contact Hannah.",
    accentColor: { light: "#26b7fd", dark: "#26b7fd" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_icon",
    icon: "atlaskit/WatchIcon",
    colorMute: false,
  },

  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Monthly Update",
    text: "This Friday at 16:00, we’re meeting for our Monthly Update. We’ll cover key highlights, recent achievements, and upcoming plans. Looking forward to seeing you there.",
    accentColor: { light: "#ff6f00", dark: "#ff6f00" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["title", "text"],
    type: "dot",
    colorMute: true,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Confidential Information",
    text: "The information below is confidential and intended for internal use only. Please do not share it outside the company or with unauthorized individuals. If you have any questions about data security or sharing guidelines, contact Hannah.",
    accentColor: { light: "#FBFBFB", dark: "#FBFBFB" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_emoji",
    icon: {
      id: "shushing_face",
      name: "Face with Finger Covering Closed Lips",
      short_names: ["shushing_face", "face_with_finger_covering_closed_lips"],
      colons: ":shushing_face:",
      emoticons: [],
      unified: "1f92b",
      skin: null,
      native: "🤫",
    },
    colorMute: false,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Employee Handbook",
    text: "Welcome to Our Employee Handbook. This guide covers everything you need to know about our company, policies, and expectations. Have questions? Reach out to Hannah, she’s happy to help!",
    accentColor: { light: "#FBFBFB", dark: "#FBFBFB" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "text"],
    type: "custom_emoji",
    icon: {
      id: "wave",
      name: "Waving Hand Sign",
      short_names: ["wave"],
      colons: ":wave:",
      emoticons: [],
      unified: "1f44b",
      skin: 1,
      native: "👋",
    },
    colorMute: false,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Employee Handbook",
    text: "Welcome to Our Employee Handbook. This guide covers everything you need to know about our company, policies, and expectations. Have questions? Reach out to Hannah, she’s happy to help!",
    accentColor: { light: "#ff1acc", dark: "#ff1acc" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "text"],
    type: "custom_emoji",
    icon: {
      id: "wave",
      name: "Waving Hand Sign",
      short_names: ["wave"],
      colons: ":wave:",
      emoticons: [],
      unified: "1f44b",
      skin: 1,
      native: "👋",
    },
    colorMute: true,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Employee Handbook",
    text: "Welcome to Our Employee Handbook. This guide covers everything you need to know about our company, policies, and expectations. Have questions? Reach out to Hannah, she’s happy to help!",
    accentColor: { light: "#00eafc", dark: "#00eafc" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "text"],
    type: "custom_emoji",
    icon: {
      id: "wave",
      name: "Waving Hand Sign",
      short_names: ["wave"],
      colons: ":wave:",
      emoticons: [],
      unified: "1f44b",
      skin: 1,
      native: "👋",
    },
    colorMute: true,
  },
];

export const OVERVIEW_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Gift Boxes",
    text: "We're sending gift boxes to our top-selling partners as a token of appreciation and to strengthen our personal connections. This is especially important for partners who have been less engaged, giving us a thoughtful way to reconnect.",
    accentColor: { light: "#ff2fd2", dark: "#ff2fd2" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_icon",
    icon: "bootstrap/Gift",
    colorMute: true,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Monthly Update",
    text: "This Friday at 16:00, we’re meeting for our Monthly Update. We’ll cover key highlights, recent achievements, and upcoming plans. Looking forward to seeing you there.",
    accentColor: { light: "#ff6f00", dark: "#ff6f00" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["title", "text"],
    type: "dot",
    colorMute: true,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Confidential Information",
    text: "The information below is confidential and intended for internal use only. Please do not share it outside the company or with unauthorized individuals. If you have any questions about data security or sharing guidelines, contact Hannah.",
    accentColor: { light: "#FBFBFB", dark: "#FBFBFB" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_emoji",
    icon: {
      id: "shushing_face",
      name: "Face with Finger Covering Closed Lips",
      short_names: ["shushing_face", "face_with_finger_covering_closed_lips"],
      colons: ":shushing_face:",
      emoticons: [],
      unified: "1f92b",
      skin: null,
      native: "🤫",
    },
    colorMute: false,
  },
  {
    id: crypto.randomUUID(),
    borderRadius: 10,
    title: "Confidential Information",
    text: "The information below is confidential and intended for internal use only. Please do not share it outside the company or with unauthorized individuals. If you have any questions about data security or sharing guidelines, contact Hannah.",
    accentColor: { light: "#26b7fd", dark: "#26b7fd" },
    textColor: { light: "#000000", dark: "#000000" },
    displayElements: ["icon", "title", "text"],
    type: "custom_icon",
    icon: "atlaskit/WatchIcon",
    colorMute: false,
  },
];

export const getPanelTemplates = ({
  cornerRadius,
  selectedColors,
  isInOverview = false,
}) => {
  if (isInOverview) {
    return OVERVIEW_TEMPLATES.map((template) => ({
      ...template,
      borderRadius: cornerRadius || 10,
      ...(["custom_icon", "dot"].includes(template.type) && {
        accentColor: {
          light: selectedColors?.accent?.light || template.accentColor.light,
          dark: selectedColors?.accent?.dark || template.accentColor.dark,
        },
        textColor: {
          light: selectedColors?.text?.light || template.textColor.light,
          dark: selectedColors?.text?.dark || template.textColor.dark,
        },
      }),
    }));
  }

  const templates = PANEL_SIMPLE_TEMPLATES.map((template) => ({
    ...template,
    borderRadius: cornerRadius || 10,
    ...(["custom_icon", "dot"].includes(template.type) && {
      accentColor: {
        light: selectedColors?.accent?.light || template.accentColor.light,
        dark: selectedColors?.accent?.dark || template.accentColor.dark,
      },
      textColor: {
        light: selectedColors?.text?.light || template.textColor.light,
        dark: selectedColors?.text?.dark || template.textColor.dark,
      },
    }),
  })).reduce((acc, template) => {
    if (template.type === "standard") {
      acc.standard = [...(acc?.standard || []), template];
    }
    if (template.type === "custom_icon") {
      acc.custom_icon = [...(acc?.custom_icon || []), template];
    }
    if (template.type === "custom_emoji") {
      acc.emoji = [...(acc?.emoji || []), template];
    }
    if (template.type === "dot") {
      acc.dot = [...(acc?.dot || []), template];
    }
    return acc;
  }, {});

  return templates;
};
